import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Text } from '@coverflex-tech/hypernova';
import css from './InsuranceUpgradePlanCardHead.module.css';

export const InsuranceUpgradePlanCardHead = ({
  title,
  showBadge,
}: TInsuranceUpgradePlanCardHeadProps) => {
  const { t } = useTranslation();
  return (
    <div className={css.root}>
      <Text className={css.title} bold>
        {title}
      </Text>
      {showBadge && (
        <Badge className={css.badge} status="info">
          {t('dashboard.insurance.upgrade_plan.card.base_plan')}
        </Badge>
      )}
    </div>
  );
};

export type TInsuranceUpgradePlanCardHeadProps = {
  title?: ReactNode;
  showBadge?: boolean;
};
